/*
 * This file is generated by scripts/generate-ts-colors.ts DON'T MODIFY CONTENT HERE
 */

export enum Colors {
  background = '#f3f5f6',
  backgroundDarker = '#e3e5e8',
  backgroundGradient = 'linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(245, 248, 249, 0.99) 100%)',
  backgroundHover = '#eef0f2',
  backgroundLight = '#f9fafb',
  backgroundWhite = '#ffffff',
  black = '#000000',
  border = '#d0d9dd',
  borderLight = '#e6f0f6',
  borderSuccess = '#abc290',
  borderWarning = '#cccca4',
  color = '#5a5f72',
  colorBittersweet = '#fa2d4c',
  colorDark = '#444756',
  colorDarker = '#31343f',
  colorDarkest = '#24252d',
  colorDarkestX = '#1a1b24',
  colorGold = '#bd910c',
  colorGreen = '#1ab616',
  colorGreenHover = '#3c960c',
  colorGreenSelected = '#2d7109',
  colorLeadPurple = '#7148bd',
  colorLight = '#7c8498',
  colorLighter = '#dce2e5',
  colorOrange = '#de6603',
  colorOrangeLight = '#fae8d9',
  colorPrimary = '#1999e3',
  colorPrimaryDark = '#117cba',
  colorPrimaryDarker = '#0c6090',
  colorPrimaryDarkest = '#073155',
  colorRed = '#e50101',
  colorRedHover = '#bc0617',
  colorRedSelected = '#960303',
  colorScaleGreen = '#31bd95',
  colorViolet = '#7986cb',
  colorYellow = '#f09a0f',
  colorYellowHover = '#d69f14',
  colorYellowLight = '#fdf0db',
  colorYellowSelected = '#c27900',
  contextPrivateBackgroundDarker = '#f2f2c3',
  contextPrivateBackgroundLighter = '#ffffe7',
  errorBackground = '#ffdbd4',
  facebookColor = '#41599c',
  gplusColor = '#d34836',
  hoverBackground = '#f1faff',
  hoverLeadPurple = '#512fa2',
  hoverScaleGreen = '#1ea275',
  informationBackground = '#d1eeff',
  linkedinColor = '#2b80b5',
  naviBackground = '#e8edf1',
  personalColor = '#f09300',
  safeSharing = '#484c5b',
  successBackground = '#d6f3b4',
  successBackgroundLight = '#d6f3b4',
  twitterColor = '#3dacf0',
  warningBackground = '#ffffcd',
  white = '#ffffff',
  withBackground = 'linear-gradient(rgba(252, 253, 253, 1) 0%, rgba(240, 244, 247, 1) 0%, rgba(248, 250, 251, 1) 100%)',
  withWhiteBackground = 'linear-gradient(rgba(255, 255, 255, 1) 0%, rgba(240, 244, 247, 1) 100%)',
}
